import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useRef } from 'react';
import StyledButton from '../../../app/components/styledComponents/StyledButton';
import theme from '../../../utils/themes';
import { StyledLabel } from '../../Campaigns/CampaignDetails';
import { formErrorMessage } from '../../../app/components/formikComponents/FormErrorMessage';
import { StyledConnectedButton } from '../../../assets/styledComponents/Global';
import SuccessIcon from '../../../app/components/svgIcons/SuccessIcon';

const DynamicFormSection = ({
  sectionTitle,
  initialValues,
  buttonLabel,
  onButtonClick,
  fieldsData,
  buttonType,
  buttonIcon,
  labelText,
  buttonLoading,
  loadingText,
}) => {
  const formRef = useRef();

  // Dynamically build Yup validation schema
  const validationSchema = Yup.object(
    fieldsData.reduce((acc, field) => {
      if (field.required) {
        acc[field.name] = Yup.string().required(`Required`);
      } else {
        acc[field.name] = Yup.string();
      }
      return acc;
    }, {}),
  );

  return (
    <div className="mb-4 border rounded px-4 py-4">
      {/* Title + Button Row */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <StyledLabel size={'24px'} weight={600} color={theme.primary}>
          {sectionTitle}
        </StyledLabel>
        <div className="d-flex justify-content-center align-items-center mb-3">
          {labelText?.length > 0 && (
            <StyledConnectedButton
              className="m-2 gap-2"
              connectStatus={labelText}
              color={theme.successColorSky}
            >
              <SuccessIcon />
              {labelText}
            </StyledConnectedButton>
          )}
          <StyledButton
            className="me-3 py-2"
            variant={buttonType}
            icon={buttonIcon}
            loadingText={buttonLoading && loadingText}
            loading={buttonLoading}
            disabled={buttonLoading}
            type="button"
            onClick={() => {
              if (formRef.current) {
                formRef.current.handleSubmit(); // Trigger form submit manually
              }
            }}
          >
            {buttonLabel}
          </StyledButton>

        </div>
      </div>

      {/* Dynamic Form */}
      <Formik
        enableReinitialize={true}
        innerRef={formRef}
        initialValues={
          initialValues ||
          fieldsData.reduce((acc, field) => {
            acc[field.name] = field.initialValue || '';
            return acc;
          }, {})
        }
        validationSchema={validationSchema}
        onSubmit={(values) => {
          if (onButtonClick) onButtonClick(values); // Call parent handler
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <div className="row">
              {fieldsData.map((field, index) => (
                <div className="col-md-4 mb-3" key={index}>
                  <StyledLabel
                    size={'14px'}
                    weight={600}
                    color={theme.headingColor}
                  >
                    {field.label}
                  </StyledLabel>
                  <Field
                    disabled={field?.disabled}
                    name={field.name}
                    type={field.type || 'text'}
                    className="form-control mt-1"
                  />
                  {errors[field.name] && touched[field.name] && (
                    <ErrorMessage name={field.name} render={formErrorMessage} />
                  )}
                </div>
              ))}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default DynamicFormSection;
